import { render } from "./EditPaymentView.vue?vue&type=template&id=ba566624&scoped=true"
import script from "./EditPaymentView.vue?vue&type=script&lang=js"
export * from "./EditPaymentView.vue?vue&type=script&lang=js"

import "./EditPaymentView.vue?vue&type=style&index=0&id=ba566624&scoped=true&lang=css"

import exportComponent from "/Users/kokleng/Documents/old_macbook/document/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba566624"]])

export default __exports__